import {
  FaCode,
  FaShoppingCart,
  FaLaptopCode,
  FaMobile,
  FaPen,
  FaCogs,
  FaWordpress,
  FaChartLine,
  FaDatabase,
  FaCloud,
  FaUserShield,
  FaUsers,
  FaRobot,
  FaBrain,
  FaPalette,
  FaShopify,
} from "react-icons/fa";
// import { SiMysql } from "react-icons/si";
import { FaLink } from "react-icons/fa6";
import { RiAdvertisementFill } from "react-icons/ri";
import { SiEjs } from "react-icons/si";
import { RiCustomerService2Fill } from "react-icons/ri";
import { LiaNode } from "react-icons/lia";
import { SiReact } from "react-icons/si";
import { RiTailwindCssFill } from "react-icons/ri";
import { PiFigmaLogoFill } from "react-icons/pi";
import { ImSvg } from "react-icons/im";
import { MdOutlineAnimation } from "react-icons/md";
// import { IoLogoGooglePlaystore } from "react-icons/io5";
import { TbSeo } from "react-icons/tb";

export const API_URL = "https://inittechnology.co/web-backend";

export const Blogs_data = [
  {
    href: "/why-good-seo-is-not-cheap-and-why-its-worth-every-rupee",
    imgSrc:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/c465cda6-a595-47b5-5211-14c732896900/public", //Init_Blog11.webp
    title: "Why Good SEO Isn’t Cheap — and Why It’s Worth Every Rupee",
    author: "Naju.K",
    date: "Oct 30, 2025",
    readTime: "10 mins read",
  },
  {
    href: "/quantum-computing-is-closer-than-you-think-what-businesses-need-to-prepare-for-now",
    imgSrc:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/966c1811-0602-4cd1-d721-696a2ed7bd00/public", //Init_Blog10.webp
    title:
      "Quantum Computing Is Closer Than You Think: What Businesses Need to Prepare for Now",
    author: "Naju.K",
    date: "Oct 23, 2025",
    readTime: "5 mins read",
  },
  {
    href: "/the-rise-of-fintech-logistics-tech-how-AI-is-powering-indias-shipping-and-wallet-systems",
    imgSrc:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1f2078da-e6d4-4c0a-e777-2245cdb4f600/public", //Init_Blog9.webp
    title:
      "The Rise of FinTech + Logistics Tech: How AI is Powering India’s Shipping & Wallet Systems",
    author: "Naju.K",
    date: "Oct 07, 2025",
    readTime: "5 mins read",
  },
  {
    href: "/genAI-for-SMBs-practical-use-cases-beyond-chatGPT-in-2025",
    imgSrc:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/31d60824-71d1-44bc-5c4c-752792f68400/public", //Init_Blog8.webp
    title: "GenAI for SMBs: Practical Use Cases Beyond ChatGPT in 2025",
    author: "Naju.K",
    date: "Sep 19, 2025",
    readTime: "5 mins read",
  },
  {
    href: "/why-react-react-native-still-matter-in-the-AI-era",
    imgSrc:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/31005ed5-58b3-4a0b-4872-cd77a6a9d300/public", //Init_Blog7.webp
    title: "Why React & React Native Still Matter in the AI Era",
    author: "Sikandar.B",
    date: "Sep 05, 2025",
    readTime: "5 mins read",
  },
  {
    href: "/is-shopify-still-the-top-e-commerce-platform-in-2025",
    imgSrc:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d1d4a919-bcbb-427c-2396-fab233d11700/public", //Init_Blog6.webp
    title: "Is Shopify Still the Top E-Commerce Platform in 2025?",
    author: "Naju.K",
    date: "Feb 26, 2025",
    readTime: "2 mins read",
  },
  {
    href: "/scaling-a-SaaS-startup-in-2025-key-insights-for-success",
    imgSrc:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/17d66843-e071-481b-8d23-7307d65c7600/public", //Init_Blog5.webp
    title: "Scaling a SaaS startup in 2025: Key Insights for Success.",
    author: "Naju.K",
    date: "Feb 20, 2025",
    readTime: "4 mins read",
  },
  {
    href: "/why-businesses-will-benefit-from-AI-powered-web-apps-in-2025",
    imgSrc:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f5f5b1de-09f8-4d44-9095-124cbc7a2000/public", //Init_Blog4.webp
    title: "Why Businesses Will Benefit from AI-Powered Web Apps in 2025.",
    author: "Naju.K",
    date: "Feb 10, 2025",
    readTime: "3 mins read",
  },
  {
    href: "/tech-trends-2024-how-SaaS-is-changing-the-software-industry",
    imgSrc:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a74e281a-2bf2-4313-b973-7a62ca56f100/public", //Init_Blog3.webp
    title: "Tech Trends 2024: How SaaS is changing the Software Industry",
    author: "Naju.K",
    date: "Sep 14, 2024",
    readTime: "4 mins read",
  },
  {
    href: "/tech-trends-2024-why-react-is-the-best-choice-for-modern-web-apps",
    imgSrc:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a25d6635-69c1-4c9b-868f-2e4ed302a100/public", //Init_Blog2.webp
    title: "Tech Trends 2024: Why React is the Best Choice for Modern Web Apps",
    author: "Naju.K",
    date: "Sep 10, 2024",
    readTime: "6 mins read",
  },
  {
    href: "/tech-trends-2024-what-s-hot-in-IT",
    imgSrc:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/b3a2e345-510a-4030-444c-8dbccf803f00/public", //Init_Blog1.webp
    title: "Tech Trends 2024: What’s Hot in IT",
    author: "Naju.K",
    date: "Sep 01, 2024",
    readTime: "3 mins read",
  },
];

export const services = [
  {
    id: 1,
    title: "Website Designing & Development",
    serviceLink: "website-designing-and-development",
    description:
      "No more looking around—Init Technology brings you an affordable destination for Modern and Chic Web Development Solutions.",
    icon: <FaCode />,
    viewMore: true,
    content1:
      "With a perfect blend of creativity, technical expertise, and user-centric design principles, we craft bespoke web solutions that resonate with your target audience, enhance your brand identity, and achieve your business goals.",
    content2:
      "Init Technology provides various types of development services to create websites, such as:",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "Custom Website Design",
    bullet2: "Responsive Web Development",
    bullet3: "E-commerce Development",
    bullet4: "Website Maintenance and Support",
    bullet5: "",
  },
  {
    id: 2,
    title: "E-Commerce Development",
    serviceLink: "e-commerce-development",
    description:
      "From user-friendly interfaces to payment integration and mobile responsiveness, we'll ensure that your e-commerce website is optimised for success.",
    icon: <FaShoppingCart />,
    viewMore: true,
    content1:
      "At Init Technology, we specialise in crafting dynamic and user-friendly e-commerce solutions. Our team of experienced developers and designers utilises modern technologies to deliver online storefronts that drive sales and enhance customer experiences. We take care of the UI/UX designing too, so that you don't have to!",
    content2: "Init Technology covers all that you need, including:",
    content3: "",
    content4: "",
    content5: "and more!!",
    bullet1: "Payment Gateway Integration",
    bullet2: "Shipping Information",
    bullet3: "Inventory Management",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 3,
    title: "Software Development",
    serviceLink: "software-development",
    description:
      "Whether you need a custom web application, mobile app, or enterprise software solution, we have the expertise to bring your vision to life.",
    icon: <FaLaptopCode />,
    viewMore: true,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 4,
    title: "Mobile App Development",
    serviceLink: "mobile-app-development",
    description:
      "We leverage the latest technologies and best practices to ensure that your app is not only functional but also scalable, secure, and user-friendly.",
    icon: <FaMobile />,
    viewMore: true,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 5,
    title: "Written Production",
    serviceLink: "written-production",
    description:
      "We understand the power of words. From writing captivating content for your website to engaging articles for your blog, our team of experienced writers crafts words that convert.",
    icon: <FaPen />,
    viewMore: true,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 6,
    title: "Management Services",
    serviceLink: "management-services",
    description:
      "Explore our management services below to learn how we can support your organisation's growth and development.",
    icon: <FaCogs />,
    viewMore: true,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 7,
    title: "WordPress",
    serviceLink: "wordpress",
    description:
      "Work with our experienced designers to create a unique and visually stunning website that reflects your brand identity.",
    icon: <FaWordpress />,
    viewMore: true,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 8,
    title: "SEO",
    serviceLink: "seo",
    description:
      "With millions of websites competing for attention online, it's crucial to ensure that your website ranks well in search engine results to attract organic traffic and reach your target audience effectively.",
    icon: <FaChartLine />,
    viewMore: true,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 9,
    title: "Data Engineering and Analytics",
    description:
      "We assist you in understanding your data into valuable insights through data pipelines, predictive analytics, and business intelligence solutions. Together, let's make informed, data-driven decisions!",
    icon: <FaDatabase />,
    viewMore: false,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 10,
    title: "SaaS Development",
    description:
      "Have a fantastic concept for a cloud-based SaaS platform? We're ready to create scalable, multi-tenant applications with smooth API integrations that evolve alongside your business.",
    icon: <FaCloud />,
    viewMore: false,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 11,
    title: "Cybersecurity Services",
    description:
      "Ensure your business's safety with our professional cybersecurity services. We offer everything from vulnerability assessments to compliance consulting, helping you safeguard your data and systems against cyber threats.",
    icon: <FaUserShield />,
    viewMore: false,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 12,
    title: "IT Staff Augmentation",
    description:
      "Are you looking to expand your team? Our talented IT professionals are prepared to step in and achieve results. Whether you need software developers, designers, or tech consultants, we have the expertise you're seeking.",
    icon: <FaUsers />,
    viewMore: false,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 13,
    title: "IoT Solutions",
    description:
      "Embrace the future with IoT-enabled systems! We focus on integrating smart devices, providing real-time monitoring, and developing IoT applications to enhance your operations and connect your business.",
    icon: <FaRobot />,
    viewMore: false,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 14,
    title: "AI-Powered Solutions",
    description:
      "Enhance your operations with AI tools such as smart chatbots, machine learning systems, and AI-driven suggestions. Together, we can introduce innovation to your business!",
    icon: <FaBrain />,
    viewMore: false,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 15,
    title: "Digital Product Design",
    description:
      "Exceptional UI/UX design is essential for capturing user interest. Init develops digital experiences that resonate with your brand and bring joy to your customers, ranging from interactive prototypes to stunning interfaces.",
    icon: <FaPalette />,
    viewMore: false,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
  {
    id: 16,
    title: "IT Consulting Services",
    description:
      "Technology can feel daunting, but our IT consulting specialists simplify the process. We assist you with IT strategy development, optimising your infrastructure, and creating customised solutions that lead to success.",
    icon: <RiCustomerService2Fill />,
    viewMore: false,
    content1: "",
    content2: "",
    content3: "",
    content4: "",
    content5: "",
    bullet1: "",
    bullet2: "",
    bullet3: "",
    bullet4: "",
    bullet5: "",
  },
];

export const All_Projects = [
  {
    id: 1,
    name: "SOHAM VILLAS",
    services: [
      "Website Designing & Development",
      "E-Commerce Development",
      "Written Production",
      "Management Services",
      "SEO",
    ],
    caseStudyLink: "soham-villas",
    timeframe: "2 Months",
    role: "Full Cycle Website Recreation",
    description:
      "Soham Villas, a premium company founded in 2018, is a collection of luxury property rentals in Goa.",
    technologies: ["ReactJs", "NodeJs", "Figma", "Tailwind", "SVG"],
    iconMapping: [
      // {
      //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
      //   title: "SEO",
      //   icon: TbSeo,
      //   color: "text-blue-500",
      //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
      //   position: "bottom-8 right-8",
      // },
      {
        names: ["NodeJs"],
        title: "NodeJs",
        icon: LiaNode,
        color: "text-green-600",
        animate: { x: [0, 10, 0], y: [0, -10, 0] },
        position: "top-6 left-4",
      },
      {
        names: ["SEO"],
        title: "SEO",
        icon: TbSeo,
        color: "text-sky-600",
        animate: { x: [0, 0, 0], y: [0, 10, 0] },
        position: "top-40 -left-5 lg:-left-8",
      },
      {
        names: ["Tailwind"],
        title: "Tailwind",
        icon: RiTailwindCssFill,
        color: "text-sky-400",
        animate: { x: [20, 10, 20], y: [0, 10, 0] },
        position: "bottom-8 right-8",
      },
      {
        names: ["Figma"],
        title: "Figma",
        icon: PiFigmaLogoFill,
        color: "text-pink-400",
        animate: { x: [20, 10, 20], y: [10, 10, 10] },
        position: "-bottom-2 left-16",
      },
      {
        names: ["ReactJs"],
        title: "ReactJs",
        icon: SiReact,
        color: "text-teal-300",
        animate: { x: [0, -10, 0], y: [0, -10, 0] },
        position: "-top-3 right-16",
      },
      {
        names: ["SVG"],
        title: "SVG",
        icon: ImSvg,
        color: "text-amber-500",
        animate: { x: [10, 10, 10], y: [0, 10, 0] },
        position: "top-20 -right-2",
      },
    ],
    features: [
      "Website",
      "Admin Panel",
      "Management Services",
      "SEO",
      "Content Writing",
    ],
    images_laptop: [
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a9c05ac6-615b-41a4-7928-8153596a1d00/public", //init_soham_ss1.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/958a939f-735d-4bfd-e6ed-8a9110d5f000/public", //init_soham_ss2.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/80071016-a78a-42e5-343f-251277a4c600/public", //init_soham_ss3.webp
      "../assets/Init_sohamWeb_home.png", // Init_sohamWeb_home.webp
      "../assets/Init_sohamWeb_villas.png", // Init_sohamWeb_villas.webp
      "../assets/Init_sohamWeb_propertyManagement.png", // Init_sohamWeb_propertyManagement.webp
    ],
    images_mobile: [
      "../assets/Init_sohamMob_home.png", // Init_sohamMob_home.webp
      "../assets/Init_sohamMob_apartments.png", // Init_sohamMob_apartments.webp
      "../assets/Init_sohamMob_propertyManagement.png", // Init_sohamMob_propertyManagement.webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/383cd306-53a5-4228-5aa2-b2ec553fcb00/public", //Init_logo_sohamVillas.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d84f0cec-3697-4910-0ffc-a8af66f8ba00/public", // Init_logo_sohamVillas_white.webp
    link: "https://sohamvillas.com/",
    description2:
      "Our mission with Soham Villas was to create a visually appealing, and easy to use website for everyone across the globe, aiming to effectively showcase their beautiful properties. The entire team worked together, and the final outcome soars our vision and commitment to deliver a website that showcases what Soham Villas truly stands for.",
  },
  {
    id: 2,
    name: "RPJ HOTEL",
    services: [
      "Website Designing & Development",
      "E-Commerce Development",
      "Written Production",
      "Management Services",
      "SEO",
    ],
    caseStudyLink: "rpj-hotel",
    timeframe: "3 Months",
    role: "Full Cycle Website Recreation alongside a Web-app",
    description:
      "Nestled in the heart of lush Rajkot — RPJ has been at your service for the last 16 years as the centre of emerging hospitality business in Gujarat.",
    technologies: ["ReactJs", "NodeJs", "Figma", "Tailwind", "SVG"],
    iconMapping: [
      // {
      //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
      //   title: "SEO",
      //   icon: TbSeo,
      //   color: "text-blue-500",
      //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
      //   position: "bottom-8 right-8",
      // },
      {
        names: ["NodeJs"],
        title: "NodeJs",
        icon: LiaNode,
        color: "text-green-600",
        animate: { x: [0, 10, 0], y: [0, -10, 0] },
        position: "top-6 left-4",
      },
      {
        names: ["SEO"],
        title: "SEO",
        icon: TbSeo,
        color: "text-sky-600",
        animate: { x: [0, 0, 0], y: [0, 10, 0] },
        position: "top-40 -left-5 lg:-left-8",
      },
      {
        names: ["Tailwind"],
        title: "Tailwind",
        icon: RiTailwindCssFill,
        color: "text-sky-400",
        animate: { x: [20, 10, 20], y: [0, 10, 0] },
        position: "bottom-8 right-8",
      },
      {
        names: ["Figma"],
        title: "Figma",
        icon: PiFigmaLogoFill,
        color: "text-pink-400",
        animate: { x: [20, 10, 20], y: [10, 10, 10] },
        position: "-bottom-2 left-16",
      },
      {
        names: ["ReactJs"],
        title: "ReactJs",
        icon: SiReact,
        color: "text-teal-300",
        animate: { x: [0, -10, 0], y: [0, -10, 0] },
        position: "-top-3 right-16",
      },
      {
        names: ["SVG"],
        title: "SVG",
        icon: ImSvg,
        color: "text-amber-500",
        animate: { x: [10, 10, 10], y: [0, 10, 0] },
        position: "top-20 -right-2",
      },
    ],
    features: [
      "Website",
      "Web-app",
      "Management Services",
      "SEO",
      "Content Writing",
    ],
    images_laptop: [
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/774e0559-03bc-496f-251f-7c5ddd7dc800/public", //init_rpj_ss1.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a4564cb2-9fac-449d-7c36-350ddd410400/public", //init_rpj_ss2.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0ae77245-fb51-49b9-d6ba-9819f15cea00/public", //init_rpj_ss3.webp
      "../assets/Init_rpjWeb_home.png", // Init_rpjWeb_home.webp
      "../assets/Init_rpjWeb_hotCrusty.png", // Init_rpjWeb_hotCrusty.webp
      "../assets/Init_rpjWeb_gravity.png", // Init_rpjWeb_gravity.webp
    ],
    images_mobile: [
      "../assets/Init_rpjMob_home.png", // Init_rpjMob_home.webp
      "../assets/Init_rpjMob_hotCrusty.png", // Init_rpjMob_hotCrusty.webp
      "../assets/Init_rpjMob_eventGallery.png", // Init_rpjMob_eventGallery.webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/57fb91a3-3a6b-445c-d943-c23e952cdf00/public", //Init_logo_rpj.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/57fb91a3-3a6b-445c-d943-c23e952cdf00/public", //Init_logo_rpj.webp
    link: "https://rpjhotels.com/",
    description2:
      "In our collaborate with RPJ Hotel, we created a simple, yet captivating website that majorly focuses on user experience. Our goal was to visually showcase the rooms, capturing the essence of it’s hospitality services and management.",
  },
  {
    id: 3,
    name: "DRESSWALA NX",
    caseStudyLink: "dresswala-nx",
    services: [
      "Website Designing & Development",
      "Written Production",
      "Management Services",
      "SEO",
    ],
    timeframe: "1 Month",
    role: "Full Cycle Website Recreation",
    description:
      "Founded on a passion for fashion and a commitment to quality, Dresswala is dedicated to providing you with the latest trends and timeless classics. Whether you are looking for the perfect outfit for a special occasion or everyday wear that makes you feel fabulous, they’ve got you covered.",
    technologies: ["Shopify", "LiquidJs"],
    iconMapping: [
      // {
      //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
      //   title: "SEO",
      //   icon: TbSeo,
      //   color: "text-blue-500",
      //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
      //   position: "bottom-8 right-8",
      // },
      // {
      //   names: ["NodeJs"],
      //   title: "NodeJs",
      //   icon: LiaNode,
      //   color: "text-green-600",
      //   animate: { x: [0, 10, 0], y: [0, -10, 0] },
      //   position: "top-6 left-2",
      // },
      // {
      //   names: ["Tailwind"],
      //   title: "Tailwind",
      //   icon: RiTailwindCssFill,
      //   color: "text-sky-400",
      //   animate: { x: [0, 10, 0], y: [0, 10, 0] },
      //   position: "top-40 -left-6 lg:-left-8",
      // },
      {
        names: ["LiquidJs"],
        title: "LiquidJs",
        icon: SiEjs,
        color: "text-sky-600",
        animate: { x: [20, 10, 20], y: [0, 10, 0] },
        position: "bottom-8 right-8",
      },
      // {
      //   names: ["LiquidJs"],
      //   title: "LiquidJs",
      //   icon: PiFigmaLogoFill,
      //   color: "text-pink-400",
      //   animate: { x: [20, 10, 20], y: [10, 10, 10] },
      //   position: "-bottom-2 left-16",
      // },
      {
        names: ["Shopify"],
        title: "Shopify",
        icon: FaShopify,
        color: "text-green-600",
        animate: { x: [0, -10, 0], y: [0, -10, 0] },
        position: "-top-3 right-16",
      },
      // {
      //   names: ["SVG"],
      //   title: "SVG",
      //   icon: ImSvg,
      //   color: "text-amber-500",
      //   animate: { x: [10, 10, 10], y: [0, 10, 0] },
      //   position: "top-20 -right-2",
      // },
    ],
    features: ["Website", "Management Services", "SEO", "Content Writing"],
    images_laptop: [
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/993d0862-cdac-4ba4-e167-06b5ba1e1200/public", //init_dw_ss1.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d62e996b-ca88-4d46-5425-e43493953f00/public", //init_dw_ss2.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/cbcb7e36-715b-499e-72d8-06671ad47600/public", //init_dw_ss3.webp
      "../assets/Init_dresswalaWeb_home.png", // Init_dresswalaWeb_home.webp
      "../assets/Init_dresswalaWeb_indoWestern.png", // Init_dresswalaWeb_indoWestern.webp
      "../assets/Init_dresswalaWeb_bundiSet.png", // Init_dresswalaWeb_bundiSet.webp
    ],
    images_mobile: [
      "../assets/Init_dresswalaMob_home.png", // Init_dresswalaMob_home.webp
      "../assets/Init_dresswalaMob_bandhgala.png", // Init_dresswalaMob_bandhgala.webp
      "../assets/Init_dresswalaMob_safa.png", // Init_dresswalaMob_safa.webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/db29e86c-bccb-44c8-af08-e385f7951b00/public", //Init_logo_dresswala.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/8e6e9092-eb39-42df-fec7-c9ab869c5a00/public", // Init_logo_dresswala_white.webp
    link: "https://dresswalanx.com/",
    description2:
      "The main goal for Dresswala was to optimize the space for text and images, and also make sure that the website runs effortlessly, delivering a smooth user experience. During the period of this collaboration we continue to update the images, and keep providing only the best for everyone.",
  },
  {
    id: 4,
    name: "NEEL AYURVEDICS",
    services: ["Software Development", "Management Services"],
    caseStudyLink: "neel-ayurvedics",
    timeframe: "3 Months",
    role: "Full Cycle Web-App Creation",
    description:
      "At Neel Ayurvedics, our mission is to make the healing power of Ayurveda accessible to all. We believe in empowering individuals to take charge of their well-being by providing natural products that align with the principles of Ayurveda. ",
    technologies: ["ReactJs", "NodeJs", "Figma", "CSS3", "SVG"],
    iconMapping: [
      // {
      //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
      //   title: "SEO",
      //   icon: TbSeo,
      //   color: "text-blue-500",
      //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
      //   position: "bottom-8 right-8",
      // },
      {
        names: ["NodeJs"],
        title: "NodeJs",
        icon: LiaNode,
        color: "text-green-600",
        animate: { x: [0, 10, 0], y: [0, -10, 0] },
        position: "top-6 left-4",
      },
      // {
      //   names: ["Tailwind"],
      //   title: "Tailwind",
      //   icon: RiTailwindCssFill,
      //   color: "text-sky-400",
      //   animate: { x: [0, 10, 0], y: [0, 10, 0] },
      //   position: "top-40 -left-6 lg:-left-8",
      // },
      {
        names: ["Tailwind"],
        title: "Tailwind",
        icon: RiTailwindCssFill,
        color: "text-sky-400",
        animate: { x: [20, 10, 20], y: [0, 10, 0] },
        position: "bottom-8 right-8",
      },
      {
        names: ["Figma"],
        title: "Figma",
        icon: PiFigmaLogoFill,
        color: "text-pink-400",
        animate: { x: [20, 10, 20], y: [10, 10, 10] },
        position: "-bottom-2 left-16",
      },
      {
        names: ["ReactJs"],
        title: "ReactJs",
        icon: SiReact,
        color: "text-teal-300",
        animate: { x: [0, -10, 0], y: [0, -10, 0] },
        position: "-top-3 right-16",
      },
      {
        names: ["SVG"],
        title: "SVG",
        icon: ImSvg,
        color: "text-amber-500",
        animate: { x: [10, 10, 10], y: [0, 10, 0] },
        position: "top-20 -right-2",
      },
    ],
    features: ["Web-app", "Management Services"],
    images_laptop: [
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a3520b67-0509-481b-b7ae-94575d982c00/public", //init_neel_ss1.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/3e06eecf-e5fa-4aef-37d8-98fb4bd04900/public", //init_neel_ss2.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/87603076-00a2-4f6c-7e1d-83a34ff4ec00/public", //init_neel_ss3.webp
      "../assets/Init_neelWeb_login.png", // Init_neelWeb_login.webp
      "../assets/Init_neelWeb_home.png", // Init_neelWeb_home.webp
      "../assets/Init_neelWeb_integration.png", // Init_neelWeb_integrationS.webp
      "../assets/Init_neelWeb_calculator.png", // Init_neelWeb_calculator.webp
    ],
    images_mobile: [
      // "../assets/.png", // .webp
      // "../assets/.png", // .webp
      // "../assets/.png", // .webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/fd16ca85-2ecc-4b97-2072-8a66843e6500/public", //Init_logo_neelAyurvedics.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/75401c88-9cd4-4995-cde3-f00f7377fa00/public", // Init_logo_neelAyurvedics_white.webp
    link: "https://dash.shipneel.in/",
    description2:
      "We developed a comprehensive web-app for Neel Ayurvedics to enhance accessibility and improve user experience. We continue to refine the web-app with new versions, ensuring it remains intuitive and up-to-date with the latest offerings.",
  },
  {
    id: 5,
    name: "OPEN STUDIOS",
    services: [
      "Website Designing & Development",
      "Written Production",
      "Management Services",
      "SEO",
    ],
    caseStudyLink: "open-studios",
    timeframe: "2 Months",
    role: "Full Cycle Website Creation",
    description:
      "Open Studios, your go-to creative hub in Rajkot! We are passionate about helping businesses shine with our award-winning advertising services. From stunning Photography & Cinematography to dynamic Social Media Management and cutting-edge 3D Visualisations, we bring your vision to life.",
    technologies: ["ReactJs", "NodeJs", "Figma", "Tailwind", "Lottiefiles"],
    iconMapping: [
      // {
      //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
      //   title: "SEO",
      //   icon: TbSeo,
      //   color: "text-blue-500",
      //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
      //   position: "bottom-8 right-8",
      // },
      {
        names: ["NodeJs"],
        title: "NodeJs",
        icon: LiaNode,
        color: "text-green-600",
        animate: { x: [0, 10, 0], y: [0, -10, 0] },
        position: "top-6 left-4",
      },
      {
        names: ["SEO"],
        title: "SEO",
        icon: TbSeo,
        color: "text-sky-600",
        animate: { x: [0, 10, 0], y: [0, 10, 0] },
        position: "top-40 -left-6 lg:-left-8",
      },
      {
        names: ["Tailwind"],
        title: "Tailwind",
        icon: RiTailwindCssFill,
        color: "text-sky-400",
        animate: { x: [20, 10, 20], y: [0, 10, 0] },
        position: "bottom-8 right-8",
      },
      {
        names: ["Lottiefiles"],
        title: "Lottiefiles",
        icon: MdOutlineAnimation,
        color: "text-amber-500",

        animate: { x: [20, 10, 20], y: [10, 10, 10] },
        position: "-bottom-2 left-16",
      },
      {
        names: ["ReactJs"],
        title: "ReactJs",
        icon: SiReact,
        color: "text-teal-300",
        animate: { x: [0, -10, 0], y: [0, -10, 0] },
        position: "-top-3 right-16",
      },
      {
        names: ["Figma"],
        title: "Figma",
        icon: PiFigmaLogoFill,
        color: "text-pink-400",
        animate: { x: [10, 10, 10], y: [0, 10, 0] },
        position: "top-20 -right-2",
      },
    ],
    features: ["Website", "Management Services", "SEO", "Content Writing"],
    images_laptop: [
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/5538230c-3e86-4826-27ce-12bc48783100/public", //init_os_ss1.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/6e6bc102-ff28-4580-ed5b-b5543572ee00/public", //init_os_ss2.webp
      // "../assets/CaseStudy/init_os_ss3.webp", //init_os_ss3.webp
      "../assets/Init_OSWeb_home.png", // Init_OSWeb_home.webp
      "../assets/Init_OSWeb_socialMedia.png", // Init_OSWeb_socialMedia.webp
      "../assets/Init_OSWeb_brochure.png", // Init_OSWeb_brochure.webp
    ],
    images_mobile: [
      "../assets/Init_OSMob_home.png", // Init_OSMob_home.webp
      "../assets/Init_OSMob_socialMedia.png", // Init_OSMob_socialMedia.webp
      "../assets/Init_OSMob_brochure.png", // Init_OSMob_brochure.webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e7c0773e-6ce7-4418-74aa-063c81d52600/public", //Init_logo_openStudios.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d97b9f04-1043-401d-03c0-9d2c023ba700/public", // Init_logo_openStudios_white.webp
    link: "https://open-studios.co/",
    description2:
      "We are building a dynamic website for Open Studios to showcase their  services. The site will provide a seamless experience, offering access to stunning Photography, Cinematography, Social Media Management, and beautiful 3D Visualisations. Our goal is to continuously update the platform to bring businesses visions to life while maintaining a sleek and user-friendly design.",
  },
  {
    id: 6,
    name: "HOUSE OF SHAH",
    services: [
      "WordPress",
      "E-Commerce Development",
      "Management Services",
      "SEO",
    ],
    caseStudyLink: "house-of-shah",
    timeframe: "2 Months",
    role: "Full Cycle E-Website Creation",
    description:
      "Based in Rajkot, House of Shah is an up-and-coming name in the world of silver jewellery. With years of experience, they pride ourselves on creating high-quality, beautifully designed pieces that stand the test of time.",
    technologies: ["Wordpress", "Figma"],
    iconMapping: [
      // {
      //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
      //   title: "SEO",
      //   icon: TbSeo,
      //   color: "text-blue-500",
      //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
      //   position: "bottom-8 right-8",
      // },
      // {
      //   names: ["NodeJs"],
      //   title: "NodeJs",
      //   icon: LiaNode,
      //   color: "text-green-600",
      //   animate: { x: [0, 10, 0], y: [0, -10, 0] },
      //   position: "top-6 left-4",
      // },
      // {
      //   names: ["Tailwind"],
      //   title: "Tailwind",
      //   icon: RiTailwindCssFill,
      //   color: "text-sky-400",
      //   animate: { x: [0, 10, 0], y: [0, 10, 0] },
      //   position: "top-40 -left-6 lg:-left-8",
      // },
      // {
      //   names: ["Tailwind"],
      //   title: "Tailwind",
      //   icon: RiTailwindCssFill,
      //   color: "text-sky-400",
      //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
      //   position: "bottom-8 right-8",
      // },
      {
        names: ["Figma"],
        title: "Figma",
        icon: PiFigmaLogoFill,
        color: "text-pink-400",
        animate: { x: [20, 10, 20], y: [10, 10, 10] },
        position: "-bottom-2 left-16",
      },
      {
        names: ["WordPress"],
        title: "WordPress",
        icon: FaWordpress,
        color: "text-sky-600",
        animate: { x: [0, -10, 0], y: [0, -10, 0] },
        position: "-top-3 right-16",
      },
      // {
      //   names: ["SVG"],
      //   title: "SVG",
      //   icon: ImSvg,
      //   color: "text-amber-500",
      //   animate: { x: [10, 10, 10], y: [0, 10, 0] },
      //   position: "top-20 -right-2",
      // },
    ],
    features: ["E-commerce Website", "Management Services"],
    images_laptop: [
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/afdfc045-32a9-4045-92e9-ae5c7dd42f00/public", //init_houseOfShah_ss1.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0754d003-d18e-49b3-c141-5aa15695fb00/public", //init_houseOfShah_ss2.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/08a06bd0-95dc-40b5-b9cb-b14221987e00/public", //init_houseOfShah_ss3.webp
      "../assets/Init_HOSWeb_home.png", // Init_HOSWeb_home.webp
      "../assets/Init_HOSWeb_shop.png", // Init_HOSWeb_shop.webp
      "../assets/Init_HOSWeb_expertise.png", // Init_HOSWeb_expertise.webp
    ],
    images_mobile: [
      "../assets/Init_HOSMob_home.png", // Init_HOSMob_home.webp
      "../assets/Init_HOSMob_about.png", // Init_HOSMob_about.webp
      "../assets/Init_HOSMob_contact.png", // Init_HOSMob_contact.webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f0764662-e5fa-4206-bfe9-833f5f901500/public", //Init_logo_houseOfShah.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/5b688f78-d3b6-4e0d-f087-e43c0a8e5400/public", // Init_logo_houseOfShah_white.webp
    link: "https://houseofshah.in/",
    description2:
      "With House of Shah, our truest challenge was that it came along with multiple plugin variations, and a very intricate set of functionality. However at Init we say “Nothing is impossible”, therefore this creation is one of its kind, with its elegant and minimal designing. We ensure complete client discrepancy and regular updates.",
  },
  // {
  //   id: 7,
  //   name: "HARI AUM DESIGNS",
  //   services: ["Mobile App Development", "Management Services"],
  //   caseStudyLink: "hari-aum-designs",
  //   timeframe: "6 Months",
  //   role: "Full Cycle App Creation",
  //   description:
  //     "Hari Aum Designs is dedicated to crafting beautiful, custom interiors that blend practically with enduring style. They emphasise innovative design solutions for both residential and commercial spaces, turning concepts into elegant environments.",
  //   technologies: [
  //     "ReactNative",
  //     "NodeJS",
  //     "MySQL",
  //     "Tailwind",
  //     "Figma",
  //     "App/Play Store",
  //   ],
  //   iconMapping: [
  //     // {
  //     //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
  //     //   title: "SEO",
  //     //   icon: TbSeo,
  //     //   color: "text-blue-500",
  //     //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
  //     //   position: "bottom-8 right-8",
  //     // },
  //     {
  //       names: ["NodeJs"],
  //       title: "NodeJs",
  //       icon: LiaNode,
  //       color: "text-green-600",
  //       animate: { x: [0, 10, 0], y: [0, -10, 0] },
  //       position: "top-6 left-4",
  //     },
  //     {
  //       names: ["MySQL"],
  //       title: "MySQL",
  //       icon: SiMysql,
  //       color: "text-sky-600",
  //       animate: { x: [0, 10, 0], y: [0, 10, 0] },
  //       position: "top-40 -left-6 lg:-left-8",
  //     },
  //     {
  //       names: ["Tailwind"],
  //       title: "Tailwind",
  //       icon: RiTailwindCssFill,
  //       color: "text-sky-400",
  //       animate: { x: [20, 10, 20], y: [0, 10, 0] },
  //       position: "bottom-8 right-8",
  //     },
  //     {
  //       names: ["Figma"],
  //       title: "Figma",
  //       icon: PiFigmaLogoFill,
  //       color: "text-pink-400",
  //       animate: { x: [20, 10, 20], y: [10, 10, 10] },
  //       position: "-bottom-2 left-16",
  //     },
  //     {
  //       names: ["ReactNative"],
  //       title: "ReactNative",
  //       icon: SiReact,
  //       color: "text-teal-300",
  //       animate: { x: [0, -10, 0], y: [0, -10, 0] },
  //       position: "-top-3 right-16",
  //     },
  //     {
  //       names: ["Play Store"],
  //       title: "Play Store",
  //       icon: IoLogoGooglePlaystore,
  //       color: "text-teal-500",
  //       animate: { x: [10, 10, 10], y: [0, 10, 0] },
  //       position: "top-20 -right-2",
  //     },
  //   ],
  //   features: ["App", "Management Services"],
  //   images_laptop: [],
  //   images_mobile: [
  //     // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f0cdfd2e-1d4c-4240-5890-0d4d65a47c00/public", //init_hariAum_ss1.webp
  //     // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/ef788a80-3a7b-4342-8474-be44f6d08400/public", //init_hariAum_ss2.webp
  //     // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/726c9211-600c-4d71-2c16-0b2137170200/public", //init_hariAum_ss3.webp
  //     // "../assets/.png", // .webp
  //     // "../assets/.png", // .webp
  //     // "../assets/.png", // .webp
  //   ],
  //   logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9ad4087d-7760-4198-3126-df5c4875d000/public", //Init_logo_hariAum.webp
  //   white_logo:
  //     "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9ad4087d-7760-4198-3126-df5c4875d000/public", // Init_logo_hariAum.webp
  //   link: "Coming Soon",
  //   description2:
  //     "We at, Init Technology are creating a custom interior management app for Hari Aum Designs aimed at improving workflows, boosting client collaboration, and highlighting their design skills. This app will enhance their operations, making project management smoother and client interactions more effortless.",
  // },
  // {
  //   id: 8,
  //   name: "MAGIC METALS",
  //   services: ["WordPress", "Written Production", "Management Services", "SEO"],
  //   caseStudyLink: "magic-metals",
  //   timeframe: "1 Month",
  //   role: "Full Cycle Website Creation, SEO & Digital Presence Management​",
  //   description:
  //     "At Magic Metals, they focus on creating exquisite high-end motorised and manual main gates that perfectly combine elegance, functionality, and durability.",
  //   technologies: ["Wordpress", "PHP", "Figma"],
  //   iconMapping: [
  //     // {
  //     //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
  //     //   title: "SEO",
  //     //   icon: TbSeo,
  //     //   color: "text-blue-500",
  //     //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
  //     //   position: "bottom-8 right-8",
  //     // },
  //     // {
  //     //   names: ["NodeJs"],
  //     //   title: "NodeJs",
  //     //   icon: LiaNode,
  //     //   color: "text-green-600",
  //     //   animate: { x: [0, 10, 0], y: [0, -10, 0] },
  //     //   position: "top-6 left-4",
  //     // },
  //     // {
  //     //   names: ["Tailwind"],
  //     //   title: "Tailwind",
  //     //   icon: RiTailwindCssFill,
  //     //   color: "text-sky-400",
  //     //   animate: { x: [0, 10, 0], y: [0, 10, 0] },
  //     //   position: "top-40 -left-6 lg:-left-8",
  //     // },
  //     // {
  //     //   names: ["Tailwind"],
  //     //   title: "Tailwind",
  //     //   icon: RiTailwindCssFill,
  //     //   color: "text-sky-400",
  //     //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
  //     //   position: "bottom-8 right-8",
  //     // },
  //     {
  //       names: ["Figma"],
  //       title: "Figma",
  //       icon: PiFigmaLogoFill,
  //       color: "text-pink-400",
  //       animate: { x: [20, 10, 20], y: [10, 10, 10] },
  //       position: "-bottom-2 left-16",
  //     },
  //     {
  //       names: ["WordPress"],
  //       title: "WordPress",
  //       icon: FaWordpress,
  //       color: "text-sky-600",
  //       animate: { x: [0, -10, 0], y: [0, -10, 0] },
  //       position: "-top-3 right-16",
  //     },
  //     // {
  //     //   names: ["SVG"],
  //     //   title: "SVG",
  //     //   icon: ImSvg,
  //     //   color: "text-amber-500",
  //     //   animate: { x: [10, 10, 10], y: [0, 10, 0] },
  //     //   position: "top-20 -right-2",
  //     // },
  //   ],
  //   features: ["Website", "Management Services", "SEO", "Content Writing"],
  //   images_laptop: [
  //     // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a1359c3c-eb32-4478-6528-0a250b18e800/public", //init_magicMetals_ss1.webp
  //     // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e8b6a678-90c8-42b8-06a7-de2be2f6b500/public", //init_magicMetals_ss2.webp
  //     // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/dce62518-8c41-42d2-f9fd-30003ce5bb00/public", //init_magicMetals_ss3.webp
  //     // "../assets/.png", // .webp
  //     // "../assets/.png", // .webp
  //     // "../assets/.png", // .webp
  //   ],
  //   imaages_mobile: [
  //     // "../assets/.png", // .webp
  //     // "../assets/.png", // .webp
  //     // "../assets/.png", // .webp
  //   ],
  //   logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d965dc7a-d1d2-40f7-6e90-1769f4870a00/public", //Init_logo_magicMetals.webp
  //   white_logo:
  //     "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7ace9cb8-2fce-4a91-41b5-6af41d972800/public", // Init_logo_magicMetals_white.webp
  //   link: "https://magicmetals.in/",
  //   description2:
  //     "We, at Init Technology have developed a modern, easy-to-navigate website for Magic Metals, highlighting their skills in both luxurious motorised and manual main gates. With the site now operational, we are boosting their online presence through effective SEO strategies to improve visibility and reach a broader audience. Our continuous management services guarantee that the website stays current, secure, and in line with their business objectives.",
  // },
  {
    id: 9,
    name: "SHIVECHCHHA",
    timeframe: "",
    role: "Comprehensive SEO Strategy Development and Implementation",
    description:
      "At Shivechchha, they help reclaim your life through exceptional physiotherapy services. Their highly skilled and experienced physiotherapists are dedicated to assisting you in regaining optimal physical function. ",
    technologies: [
      "Off-page",
      "On-page",
      "SEO friendly",
      "Technical",
      "Analytics",
      "Monitoring",
    ],
    features: ["SEO", "Management Services", "Content Writing"],
    images: [
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/626dbcbb-3ae6-4c87-c012-adf892937e00/public", //init_shivechchha_ss1.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/ed50a9c5-db78-4fe9-d363-d64396705f00/public", //init_shivechchha_ss2.webp
      "../assets/init_shivechchha_ss3.webp", //init_shivechchha_ss3.webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/b078a825-7ad6-4653-e3eb-713820c0fd00/public", //init_shivechchha_box.webp
    white_logo: "", // .webp
    link: "https://shivechchha.com/",
    description2:
      "Our SEO service for Shivechchha focuses on boosting their online presence to connect individuals with exceptional physiotherapy services. By implementing targeted strategies and optimizing their content, we make it easier for clients to discover their dedicated team of skilled physiotherapists and regain optimal physical function.",
  },
  {
    id: 10,
    name: "NEEL AYURVEDICS DE",
    services: ["Management Services", "SEO"],
    caseStudyLink: "neel-ayurvedics-de",
    timeframe: "",
    role: "SEO & Digital Presence Management​",
    description:
      "At Neel Ayurvedics, our mission is to make the healing power of Ayurveda accessible to all. We believe in empowering individuals to take charge of their well-being by providing natural products that align with the principles of Ayurveda.",
    technologies: [
      "On-page SEO",
      "Off-page SEO",
      "Technical Page SEO",
      "Google Ads Management ",
      "Backlinking",
      "And More!",
    ],
    iconMapping: [
      // {
      //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
      //   title: "SEO",
      //   icon: TbSeo,
      //   color: "text-blue-500",
      //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
      //   position: "bottom-8 right-8",
      // },
      {
        names: ["On-page SEO"],
        title: "On-page SEO",
        icon: TbSeo,
        color: "text-green-600",
        animate: { x: [0, 10, 0], y: [0, -10, 0] },
        position: "top-6 left-4",
      },
      // {
      //   names: ["Tailwind"],
      //   title: "Tailwind",
      //   icon: RiTailwindCssFill,
      //   color: "text-sky-400",
      //   animate: { x: [0, 10, 0], y: [0, 10, 0] },
      //   position: "top-40 -left-6 lg:-left-8",
      // },
      {
        names: ["Backlinking"],
        title: "Backlinking",
        icon: FaLink,
        color: "text-gray-500",
        animate: { x: [20, 10, 20], y: [0, 10, 0] },
        position: "bottom-8 right-8",
      },
      {
        names: ["Technical Page SEO"],
        title: "Technical Page SEO",
        icon: TbSeo,
        color: "text-pink-400",
        animate: { x: [20, 10, 20], y: [10, 10, 10] },
        position: "-bottom-2 left-16",
      },
      {
        names: ["Google Ads Management"],
        title: "Google Ads Management",
        icon: RiAdvertisementFill,
        color: "text-amber-500",
        animate: { x: [0, -10, 0], y: [0, -10, 0] },
        position: "-top-3 right-16",
      },
      {
        names: ["Off-page SEO"],
        title: "Off-page SEO",
        icon: TbSeo,
        color: "text-sky-400",
        animate: { x: [10, 10, 10], y: [0, 10, 0] },
        position: "top-20 -right-2",
      },
    ],
    features: ["SEO", "Management Services"],
    images_laptop: [
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/c3ebfe0d-8a2b-4647-36f5-4a5ed720f300/public", //init_neelGermany_ss1.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0fc20f84-dd4f-4b62-0a4d-1474a1158600/public", //init_neelGermany_ss2.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/467e6cfc-05d3-4b04-91d2-f59715f62c00/public", //init_neelGermany_ss3.webp
      "../assets/.png", // .webp
      "../assets/.png", // .webp
      "../assets/.png", // .webp
    ],
    images_mobile: [
      "../assets/.png", // .webp
      "../assets/.png", // .webp
      "../assets/.png", // .webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/caf07fb4-23cf-41c5-ae63-aed84a633f00/public", //Init_logo_neelGermany.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/31fa0b55-db47-4b72-4834-3d4d86ea8000/public", // Init_logo_neelGermany_white.webp
    link: "https://neelayurvedics.de/",
    description2:
      "Our collaboration with Neel Ayurvedics is built on a common goal: to bring genuine Ayurvedic wellness to people all around the world. By taking charge of their SEO and digital strategies, we're boosting their online visibility, making it easier for individuals everywhere to find and enjoy Neel Ayurvedics' wide array of natural health products.",
  },
  {
    id: 11,
    name: "NEEL AYURVEDICS IT",
    services: ["Management Services", "SEO"],
    caseStudyLink: "neel-ayurvedics-it",
    timeframe: "",
    role: "SEO & Digital Presence Management​",
    description:
      "At Neel Ayurvedics, our mission is to make the healing power of Ayurveda accessible to all. We believe in empowering individuals to take charge of their well-being by providing natural products that align with the principles of Ayurveda.",
    technologies: [
      "On-page SEO",
      "Off-page SEO",
      "Technical Page SEO",
      "Google Ads Management ",
      "Backlinking",
      "And More!",
    ],
    iconMapping: [
      // {
      //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
      //   title: "SEO",
      //   icon: TbSeo,
      //   color: "text-blue-500",
      //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
      //   position: "bottom-8 right-8",
      // },
      {
        names: ["On-page SEO"],
        title: "On-page SEO",
        icon: TbSeo,
        color: "text-green-600",
        animate: { x: [0, 10, 0], y: [0, -10, 0] },
        position: "top-6 left-4",
      },
      // {
      //   names: ["Tailwind"],
      //   title: "Tailwind",
      //   icon: RiTailwindCssFill,
      //   color: "text-sky-400",
      //   animate: { x: [0, 10, 0], y: [0, 10, 0] },
      //   position: "top-40 -left-6 lg:-left-8",
      // },
      {
        names: ["Backlinking"],
        title: "Backlinking",
        icon: FaLink,
        color: "text-gray-500",
        animate: { x: [20, 10, 20], y: [0, 10, 0] },
        position: "bottom-8 right-8",
      },
      {
        names: ["Technical Page SEO"],
        title: "Technical Page SEO",
        icon: TbSeo,
        color: "text-pink-400",
        animate: { x: [20, 10, 20], y: [10, 10, 10] },
        position: "-bottom-2 left-16",
      },
      {
        names: ["Google Ads Management"],
        title: "Google Ads Management",
        icon: RiAdvertisementFill,
        color: "text-amber-500",
        animate: { x: [0, -10, 0], y: [0, -10, 0] },
        position: "-top-3 right-16",
      },
      {
        names: ["Off-page SEO"],
        title: "Off-page SEO",
        icon: TbSeo,
        color: "text-sky-400",
        animate: { x: [10, 10, 10], y: [0, 10, 0] },
        position: "top-20 -right-2",
      },
    ],
    features: ["SEO", "Management Services"],
    images_laptop: [
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/62dad245-e186-4f00-477c-de33e80f1800/public", //init_neelitaly_ss1.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/4c0628ae-ec45-4928-ba43-03bac7785400/public", //init_neelitaly_ss2.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9ca43278-8901-4f7c-181e-47182f9d5000/public", //init_neelitaly_ss3.webp
      "../assets/.png", // .webp
      "../assets/.png", // .webp
      "../assets/.png", // .webp
    ],
    images_mobile: [
      "../assets/.png", // .webp
      "../assets/.png", // .webp
      "../assets/.png", // .webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/25e21594-b8cf-4c60-05c7-cee98df2b600/public", //Init_logo_neelItaly.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0497efef-094d-4409-7fce-64c48df1c200/public", // Init_logo_neelItaly_white.webp
    link: "https://neelayurvedics.it/",
    description2:
      "Our collaboration with Neel Ayurvedics is built on a common goal: to bring genuine Ayurvedic wellness to people all around the world. By taking charge of their SEO and digital strategies, we're boosting their online visibility, making it easier for individuals everywhere to find and enjoy Neel Ayurvedics' wide array of natural health products.",
  },
  {
    id: 12,
    name: "TRANS GLOBE",
    services: [
      "Website Designing & Development",
      "Written Production",
      "Management Services",
      "SEO",
    ],
    caseStudyLink: "trans-globe",
    timeframe: "",
    role: "SEO & Digital Presence Management​",
    description:
      "Trans Globe, with more than 20 offices spread across India, Australia, and Nepal, we provide personalised guidance and support for every student. We see ourselves not just as consultants, but as partners in this educational adventure.",
    technologies: ["ReactJS", "NodeJs", "Figma", "CSS3", "SVG", "SEO"],
    iconMapping: [
      // {
      //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
      //   title: "SEO",
      //   icon: TbSeo,
      //   color: "text-blue-500",
      //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
      //   position: "bottom-8 right-8",
      // },
      {
        names: ["NodeJs"],
        title: "NodeJs",
        icon: LiaNode,
        color: "text-green-600",
        animate: { x: [0, 10, 0], y: [0, -10, 0] },
        position: "top-6 left-4",
      },
      {
        names: ["SEO"],
        title: "SEO",
        icon: TbSeo,
        color: "text-sky-600",
        animate: { x: [0, 0, 0], y: [0, 10, 0] },
        position: "top-40 -left-5 lg:-left-8",
      },
      {
        names: ["Tailwind"],
        title: "Tailwind",
        icon: RiTailwindCssFill,
        color: "text-sky-400",
        animate: { x: [20, 10, 20], y: [0, 10, 0] },
        position: "bottom-8 right-8",
      },
      {
        names: ["Figma"],
        title: "Figma",
        icon: PiFigmaLogoFill,
        color: "text-pink-400",
        animate: { x: [20, 10, 20], y: [10, 10, 10] },
        position: "-bottom-2 left-16",
      },
      {
        names: ["ReactJs"],
        title: "ReactJs",
        icon: SiReact,
        color: "text-teal-300",
        animate: { x: [0, -10, 0], y: [0, -10, 0] },
        position: "-top-3 right-16",
      },
      {
        names: ["SVG"],
        title: "SVG",
        icon: ImSvg,
        color: "text-amber-500",
        animate: { x: [10, 10, 10], y: [0, 10, 0] },
        position: "top-20 -right-2",
      },
    ],
    features: ["Website", "SEO", "Management Services", "Content Writing"],
    images_laptop: [
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9112f17b-5dc7-4dc0-4b99-b01b774e1600/public", //init_transglobe_ss1.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/43f4a6fa-6686-4c80-9ccc-473c9f865f00/public", //init_transglobe_ss2.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/8970f9bb-56a5-49b7-0df6-bdd1669c3d00/public", //init_transglobe_ss3.webp
      "../assets/Init_TGWeb_home.png", // Init_TGWeb_home.webp
      "../assets/Init_TGWeb_studyDesti.png", // Init_TGWeb_studyDesti.webp
      "../assets/Init_TGWeb_company.png", // Init_TGWeb_company.webp
    ],
    images_mobile: [
      "../assets/Init_TGMob_home.png", // Init_TGMob_home.webp
      "../assets/Init_TGMob_services.png", // Init_TGMob_services.webp
      "../assets/Init_TGMob_scholarship.png", // Init_TGMob_scholarship.webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/28d87ae5-1ed4-40b7-22c9-11cd8f7c4300/public", //Init_logo_transGlobe.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/85a5dd3c-0f7f-4dc6-8685-5a8d8823da00/public", // Init_logo_transGlobe_white.webp
    link: "https://transglobeedu.com/",
    description2:
      "Our mission with Trans Globe Education is fuelled by a mutual dedication to helping students thrive in their global academic pursuits. By taking charge of their SEO and online presence, we strive to broaden their reach. Together, we’re not just boosting visibility; we’re creating pathways to exciting international education opportunities.",
  },
  {
    id: 13,
    name: "ZORBA STAYS",
    services: [
      "Website Designing & Development",
      "Written Production",
      "Management Services",
      "SEO",
    ],
    caseStudyLink: "zorba-stays",
    timeframe: "2 months",
    role: "Full Cycle Website Recreation",
    description:
      "Zorba Stays provides luxurious getaways in a number of places. Zorba Stays specialises in designing environments that inspire visitors to embrace leisurely living and establish a connection with nature.",
    technologies: ["ReactJS", "NodeJs", "Figma", "CSS3", "SVG", "SEO"],
    iconMapping: [
      // {
      //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
      //   title: "SEO",
      //   icon: TbSeo,
      //   color: "text-blue-500",
      //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
      //   position: "bottom-8 right-8",
      // },
      {
        names: ["NodeJs"],
        title: "NodeJs",
        icon: LiaNode,
        color: "text-green-600",
        animate: { x: [0, 10, 0], y: [0, -10, 0] },
        position: "top-6 left-4",
      },
      {
        names: ["SEO"],
        title: "SEO",
        icon: TbSeo,
        color: "text-sky-600",
        animate: { x: [0, 0, 0], y: [0, 10, 0] },
        position: "top-40 -left-5 lg:-left-8",
      },
      {
        names: ["Tailwind"],
        title: "Tailwind",
        icon: RiTailwindCssFill,
        color: "text-sky-400",
        animate: { x: [20, 10, 20], y: [0, 10, 0] },
        position: "bottom-8 right-8",
      },
      {
        names: ["Figma"],
        title: "Figma",
        icon: PiFigmaLogoFill,
        color: "text-pink-400",
        animate: { x: [20, 10, 20], y: [10, 10, 10] },
        position: "-bottom-2 left-16",
      },
      {
        names: ["ReactJs"],
        title: "ReactJs",
        icon: SiReact,
        color: "text-teal-300",
        animate: { x: [0, -10, 0], y: [0, -10, 0] },
        position: "-top-3 right-16",
      },
      {
        names: ["SVG"],
        title: "SVG",
        icon: ImSvg,
        color: "text-amber-500",
        animate: { x: [10, 10, 10], y: [0, 10, 0] },
        position: "top-20 -right-2",
      },
    ],
    features: ["Website", "SEO", "Management Services", "Content Writing"],
    images_laptop: [
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7007f3bc-5f3b-4c7f-f69a-a59659dde400/public", //init_zorba_ss1.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/b06a51f2-dad9-4adf-9c87-23b1be066600/public", //init_zorba_ss2.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/b03f77c7-1a34-49c0-65b0-12ffaffafe00/public", //init_zorba_ss3.webp
      "../assets/Init_ZorbaWeb_home.png", // Init_ZorbaWeb_home.webp
      "../assets/Init_ZorbaWeb_villa.png", // Init_ZorbaWeb_villa.webp
      "../assets/Init_ZorbaWeb_destination.png", // Init_ZorbaWeb_destination.webp
    ],
    images_mobile: [
      "../assets/Init_ZorbaMob_home.png", // Init_ZorbaMob_home.webp
      "../assets/Init_ZorbaMob_hotel.png", // Init_ZorbaMob_hotel.webp
      "../assets/Init_ZorbaMob_properties.png", // Init_ZorbaMob_properties.webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/19a7ffbc-e70b-4805-4781-eddda0414500/public", //Init_logo_zorbaStays.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f03d4c87-feed-4cdd-9f75-0dfd8f70fa00/public", // Init_logo_zorbaStays_white.webp
    link: "https://zorbastays.com/",
    description2:
      "Curating travel experiences that foster spiritual connections with both nature and culture is something we deeply value. By managing SEO and digital strategies for Zorba Stays, we're enhancing their online presence and helping travelers from across continents discover unique and unforgettable journeys.",
  },
  {
    id: 14,
    name: "DILIP LADANI ASSOCIATES",
    services: [
      "Website Designing & Development",
      "Written Production",
      "Management Services",
      "SEO",
    ],
    caseStudyLink: "dilip-ladani-associates",
    timeframe: "2 months",
    role: "Full Cycle Website Recreation",
    description:
      "Ladani Associates stands out as a prominent real estate developer located in Rajkot, Gujarat, boasting more than 22 years of expertise in creating stunning ultra-luxurious residential, commercial, and bungalow projects.",
    technologies: ["ReactJS", "NodeJs", "Figma", "CSS3", "SVG", "SEO"],
    iconMapping: [
      // {
      //   names: ["On-page SEO", "Off-page SEO", "Technical Page SEO"],
      //   title: "SEO",
      //   icon: TbSeo,
      //   color: "text-blue-500",
      //   animate: { x: [20, 10, 20], y: [0, 10, 0] },
      //   position: "bottom-8 right-8",
      // },
      {
        names: ["NodeJs"],
        title: "NodeJs",
        icon: LiaNode,
        color: "text-green-600",
        animate: { x: [0, 10, 0], y: [0, -10, 0] },
        position: "top-6 left-4",
      },
      {
        names: ["SEO"],
        title: "SEO",
        icon: TbSeo,
        color: "text-sky-600",
        animate: { x: [0, 0, 0], y: [0, 10, 0] },
        position: "top-40 -left-5 lg:-left-8",
      },
      {
        names: ["Tailwind"],
        title: "Tailwind",
        icon: RiTailwindCssFill,
        color: "text-sky-400",
        animate: { x: [20, 10, 20], y: [0, 10, 0] },
        position: "bottom-8 right-8",
      },
      {
        names: ["Figma"],
        title: "Figma",
        icon: PiFigmaLogoFill,
        color: "text-pink-400",
        animate: { x: [20, 10, 20], y: [10, 10, 10] },
        position: "-bottom-2 left-16",
      },
      {
        names: ["ReactJs"],
        title: "ReactJs",
        icon: SiReact,
        color: "text-teal-300",
        animate: { x: [0, -10, 0], y: [0, -10, 0] },
        position: "-top-3 right-16",
      },
      {
        names: ["SVG"],
        title: "SVG",
        icon: ImSvg,
        color: "text-amber-500",
        animate: { x: [10, 10, 10], y: [0, 10, 0] },
        position: "top-20 -right-2",
      },
    ],
    features: ["Website", "SEO", "Management Services", "Content Writing"],
    images_laptop: [
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/8c89c23c-8df2-4b2d-0a00-ffabd50bd800/public", //init_ladani_ss1.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d034ddf0-4325-4df8-5793-4ba24153bb00/public", //init_ladani_ss2.webp
      // "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0807ed79-f354-4d3b-46cc-6f9c29162400/public", //init_ladani_ss3.webp
      "../assets/Init_DLAWeb_home.png", // Init_DLAWeb_home.webp
      "../assets/Init_DLAWeb_projects.png", // Init_DLAWeb_projects.webp
      "../assets/Init_DLAWeb_awards.png", // Init_DLAWeb_awards.webp
    ],
    images_mobile: [
      "../assets/Init_DLAMob_home.png", // Init_DLAMob_home.webp
      "../assets/Init_DLAMob_projects.png", // Init_DLAMob_projects.webp
      "../assets/Init_DLAMob_about.png", // Init_DLAMob_about.webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/dda040af-bfff-4421-6338-5389b6b89e00/public", //Init_logo_dla.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/dda040af-bfff-4421-6338-5389b6b89e00/public", // Init_logo_dla.webp
    link: "https://ladaniassociates.com/",
    description2:
      "Crafting architectural experiences that embody luxury and innovation is a shared passion between Init and Ladani Associates. Our comprehensive design, and development services, enhance Ladani Associates' digital presence, enabling clients to discover their exceptional real estate offerings.",
  },
  {
    id: 15,
    name: "QUOTSYNC",
    services: ["Software Development"],
    caseStudyLink: "coming-soon",
    timeframe: "",
    role: "",
    description: "",
    technologies: [],
    features: [],
    images: [
      "", //.webp
      "", //.webp
      "", //.webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/bfd83dbb-672c-443d-867d-dde8c3816e00/public", //Init_logo_quotsync.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/2433bd8f-aaea-4b88-96f6-149683bfcc00/public", // Init_logo_quotsync_white.webp
    link: "Coming Soon",
    description2: "",
  },
  {
    id: 16,
    name: "WAVERISE HUB",
    services: ["Software Development", "Mobile App Development"],
    caseStudyLink: "coming-soon",
    timeframe: "",
    role: "",
    description: "",
    technologies: [],
    features: [],
    images: [
      "", //.webp
      "", //.webp
      "", //.webp
    ],
    logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/8c71acfa-c481-4cfe-199d-5745e315f800/public", //Init_logo_waveriseHub.webp
    white_logo:
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/539fb5f1-cd54-4926-43cd-85e2ae365f00/public", // Init_logo_waveriseHub_white.webp
    link: "Coming Soon",
    description2: "",
  },
];
